<template>
  <div class="mt-3">
    <ion-text class="text-md font-bold ion-text-brand">Verification</ion-text>
    <div>
      <div
        class="text-sm ion-text-brand mt-6 mb-3 block"
        v-html="enrolMessage"
      ></div>
      <div class="ion-item-wrapper ion-item-wrapper-v7">
        <ion-item class="default" lines="none">
          <ion-input
            label-placement="floating"
            label="Verification Code"
            class="verification-code-input"
            type="tel"
            maxlength="6"
            pattern="[0-9]*"
            inputmode="numeric"
            v-model="codeEntered"
            @input="handleCodeInput"
            :disabled="mfaSaving"
            autocomplete="one-time-code"
          ></ion-input>
        </ion-item>
      </div>

      <div class="text-center text-base mt-8 mb-3">
        <div v-if="resending">
          <ion-spinner
            name="crescent"
            color="primary"
            class="my-1 mx-auto w-[16px]"
          ></ion-spinner>
        </div>
        <div v-else>
          <span class="ion-text-grey text-sm">Didn't receive a code? </span>
          <button fill="clear" @click="resend">
            <span class="ion-text-green font-bold underline">Resend</span>
          </button>
        </div>
      </div>
      <div
        v-if="resendingMessage"
        class="text-xs my-2 text-center ion-text-green fadein-500"
        v-html="resendingMessage"
      ></div>
      <div
        v-if="errorMessage"
        class="text-xs my-2 text-center ion-text-red fadein-500"
        v-html="errorMessage"
      ></div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useCustomerStore } from "@/stores";
import { storeToRefs } from "pinia";
import { useBrowser } from "@/composables/browser";
import axios from "axios";
const customerStore = useCustomerStore();
const { urls } = useBrowser();
const {
  deviceID,
  environment,
  authToken,
  mfaSaving,
  mfaEnrolMsg,
  mfaEnrolContact,
  mfaOptionSelected,
} = storeToRefs(customerStore);
const { setMfaVerificationCode, setMfaVerificationCodeCompleted } =
  customerStore;
const saving = computed(() => mfaSaving.value);
const enrolMessage = computed(() =>
  mfaEnrolMsg.value
    ? `${mfaEnrolMsg.value.slice(
        0,
        -1
      )} to: <strong class="ion-text-purple-3">${
        mfaEnrolContact.value
      }</strong>`
    : "Multi-factor Verification activation code sent"
);
const resending = ref(false);
const resendingMessage = ref("");
const errorMessage = ref("");
const codeEntered = ref("");
const codeCompleted = computed(
  () => String(verificationCode.value).length == 6
);
const verificationCode = computed(() => sanitiseInput(codeEntered.value));
const sanitiseInput = (val) => String(val).replace(/\D+/g, "");
const handleCodeInput = () => {
  setTimeout(() => {
    codeEntered.value = sanitiseInput(codeEntered.value);
    setMfaVerificationCode(codeEntered.value);
    setMfaVerificationCodeCompleted(codeCompleted.value);
  }, 100);
};
const init = () => {
  resending.value = false;
  errorMessage.value = "";
  setMfaVerificationCode(null);
  setMfaVerificationCodeCompleted(false);
};
const resend = () => {
  codeEntered.value = "";
  resending.value = true;
  setMfaVerificationCode(null);
  setMfaVerificationCodeCompleted(false);
  axios
    .post(
      urls.apiMfaEnrolResend,
      {
        device_id: deviceID.value,
        mfa_type: mfaOptionSelected.value,
        environment: environment.value,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authToken.value,
        },
      }
    )
    .then((response) => {
      resending.value = false;
      if (response.status == 200) {
        console.log(response);
        resendingMessage.value = response.data.message
          ? response.data.message
          : "MFA activation code resending was successful.";
      }
    })
    .then(() => {
      if (resendingMessage.value) {
        setTimeout(() => {
          resendingMessage.value = "";
        }, 5000);
      }
    })
    .catch((error) => {
      resending.value = false;
      if (error) {
        errorMessage.value =
          "There was an error processing your request. Please try again later.";
        setTimeout(() => {
          errorMessage.value = "";
        }, 5000);
      }
    });
};
watch(
  saving,
  () => {
    codeEntered.value = "";
  },
  { immediate: true }
);
onMounted(() => {
  init();
});
</script>
